/**
 * Nastavení zobrazení tooltipů nad features v mapě.
 */
enum FeatureTooltips {
    /**
     * Tooltipy jsou povoleny.
     */
    ENABLED = 'ENABLED',

    /**
     * Tooltipy jsou povoleny pouze pro vrstvy vyjmenované
     * v `tooltipLayers` v konfiguraci topicu mapového serveru.
     */
    ENABLED_BY_TOPIC = 'ENABLED_BY_TOPIC',

    /**
     * Tooltipy jsou zakázány.
     */
    DISABLED = 'DISABLED',
}

export default FeatureTooltips;
